import React, { useState } from "react";
import { closeSession, navigatAfterCloseSession } from "components/BosSessionFromUrl";
import { sizes } from 'logic/media-query';

// Externals
import cn from "classnames";

// DevExtreme components
import { TreeView } from 'devextreme-react';
import Button from 'devextreme-react/button';

// Component styles
import classes from "./Shared.module.scss";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sessionActions from "redux/actions/sessionActions";
import * as dataSegmentActions from "redux/actions/dataSegmentActions";

function OpenTasks(props) {
  const { currentDataSegment, openSessions, currentSessionId, navigateTo } = props;

  const isMobile = !(sizes()['screen-large']) && !(sizes()['screen-medium']);

  function createFlatView() {
    let result = openSessions
      .filter(session => session && session.taskId)
      .map(session => {
        return {
          id: session.id,
          dataSegmentId: currentDataSegment.id,
          text: session.taskDisplayName,
          target: session.originUri,
          viewports: (session.viewports || []).slice(1)   //the first viewport equals the session properties
        };
      });
    return result;
  }

  function onTreeViewItemClicked(args) {
    let target = args.itemData.target;
    openUri(target);
  }

  function onTreeViewItemCloseClicked(item) {
    let session = openSessions.find(session => session.id === item.id);
    handleCloseTask(session, currentDataSegment);
  }

  function handleCloseTask(session, dataSegment) {
    closeSession(props.sessionActions, dataSegment.authToken, session);
    if (session && session.id === currentSessionId) {
      navigatAfterCloseSession(props.history, session);
    }
  }

  function openUri(targetUri) {
    if (!targetUri.startsWith("/")) targetUri = "/" + targetUri;
    navigateTo(targetUri);
  }

  function renderCloseButton() {
    return <i className={"dx-icon-close"} />
  }

  function renderTreeViewItem(args) {
    const [isHovered, setIsHovered] = useState(false);
    const item = args.data;
    const isCurrentSession = item.id === currentSessionId;
    const hasViewports = item.viewports.length > 0;

    return (
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className={classes.treeViewItemContainer}>
          <div className={cn(classes.treeViewItemTextContainer, { "dx-theme-accent-as-text-color": isCurrentSession, "ui-font-bold-1": true })}>
            {item.text}
          </div>
          <Button
            className={classes.treeViewItemCloseButton}
            style={{ visibility: (isHovered || isMobile) ? "visible" : "hidden" }}
            stylingMode={"text"}
            render={renderCloseButton}
            onClick={() => onTreeViewItemCloseClicked(item)}
          />
        </div>

        {hasViewports
          ? (
            <div className={classes.treeViewItemContainer}>
              <ul className={classes.subListContainer} >
                {item.viewports.map((vp, i) => {
                  let lastViewport = (i === item.viewports.length - 1);
                  let highlight = isCurrentSession && lastViewport;
                  return (
                    <li key={i} className={cn({ "dx-theme-accent-as-text-color": highlight }, lastViewport ? classes.lastViewport : "")} >
                      {vp.displayName}
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : null
        }
      </div>
    );
  }

  return (
    <div className={classes.rootContainer} >
      <TreeView
        dataSource={createFlatView()}
        itemComponent={renderTreeViewItem}
        focusStateEnabled={false}
        onItemClick={onTreeViewItemClicked}
        noDataText=""
      />
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    currentDataSegment: state.dataSegments.currentDataSegment,
    openSessions: state.sessions.openSessions,
    currentSessionId: state.sessions.currentSessionId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sessionActions: bindActionCreators(sessionActions, dispatch),
    dataSegmentActions: bindActionCreators(dataSegmentActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpenTasks);
